import { convertStringBool } from './utils'

export class ActivityInformation {
  constructor(ltiRestricted, canvasConnectEnabled) {
    this.ltiRestricted = convertStringBool(ltiRestricted)
    this.canvasConnectEnabled = convertStringBool(canvasConnectEnabled)
  }

  attach() {
    // collapsible sections
    $('.options-collapsible-section').collapsibleSection({
      defaultState: 'opened',
    })

    // move the start_date next to the appropriate visibility choice item
    $('#id_availability_1').closest('label').append(' ')
    $('#id_availability_1').closest('label').append($('#id_start_date'))

    // deduction show/hide based on the late policy value
    $('#id_late_submissions')
      .off('change.show_deduct')
      .on('change.show_deduct', function () {
        if ($(this).val() === 'deduct') {
          $('#id_late_deduct').closest('tr').show()
        } else {
          $('#id_late_deduct').closest('tr').hide()
        } // if
      })
      .trigger('change.show_deduct') // trigger on page load

    // DATABASE COURSES ONLY (Course 617)
    // Specify whether or not queries using student credentials
    // should use a clean schema or the student's working schemad
    $('input[name=platform_role]')
      .off('change.show_schema')
      .on('change.show_schema', function () {
        if ($(this).val() === 'student' && $(this).prop('checked') === true) {
          $('tr[data-name=clean_schema]').show()
        } else {
          $('tr[data-name=clean_schema]').hide()
        }
      })
      .trigger('change.show_schema') // trigger on page load

    // If course is connected to LMS, do not display rule fields that are managed by the LMS
    if (this.ltiRestricted) {
      var lmsAdvisoryStr =
        '<td/><td><h3 class="d-flex justify-content-center">Handled by your LMS</h3></td>'
      if (!this.canvasConnectEnabled) {
        $("tr[data-name='due_date']").html('').replaceWith(lmsAdvisoryStr)
        $("tr[data-name='due_date_rule_switch']").hide()
      }
      $("tr[data-name='availability']").html('').replaceWith(lmsAdvisoryStr)
      $("tr[data-name='visible']").hide()
    }
  }
}
